module.exports = __webpack_public_path__ + "static/media/img8.2fa9cf2b.jpg";